import { render } from "./TallyIntegration.vue?vue&type=template&id=6d7cab19&scoped=true"
import script from "./TallyIntegration.vue?vue&type=script&lang=js"
export * from "./TallyIntegration.vue?vue&type=script&lang=js"

import "./TallyIntegration.vue?vue&type=style&index=0&id=6d7cab19&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/goldenaces-club/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7cab19"]])

export default __exports__